<template>
  <v-container fluid>
    <new-edit-sheet />
    <v-row align="center" justify="space-between" no-gutters>
      <v-col cols="8">
        <settings-breadcrumbs v-model="project" />
      </v-col>
      <v-col class="text-right">
        <v-btn color="info" class="mr-2" @click="createEditShow()">
          <v-icon class="mr-1">mdi-plus</v-icon>
          New Tag Type
        </v-btn>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        <v-alert outlined type="info" dismissible prominent icon="mdi-format-superscript">
          <h3>
            Tag Types serve as a categorization system for tags within UnStruct. Allowing for detailed organization and filtering capabilities. With UnStruct, you can:
          </h3>
          <ul>
            <li>Define and configure unique tag types to suit your organizational needs.</li>
            <li>Assign tags to incidents, cases, or signals based on these types for enhanced categorization.</li>
            <li>Customize the configuration for each tag type, optimizing the management and retrieval of tagged items.</li>
          </ul>
        </v-alert>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        <v-card elevation="0">
          <v-card-title>
            <v-text-field
              v-model="q"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              clearable
            />
          </v-card-title>
          <v-row>
            <v-col cols="12" sm="6" md="4" v-for="item in items" :key="item.id">
              <v-card outlined class="mb-3">
                <!-- Item Name -->
                <v-card-title>
                  {{ item.name }}
                  <v-spacer></v-spacer>
                  <!-- Item Actions -->
                  <v-menu bottom left>
                    <template #activator="{ on }">
                      <v-btn icon v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="createEditShow(item)">
                        <v-list-item-title>View / Edit</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-card-title>

                <!-- Item Description -->
                <v-card-subtitle class="mt-2">
                  <v-icon left>mdi-axis-arrow-info</v-icon>
                  {{ item.description }}
                  <div class="mt-4">
                    <project-card :project="item.project" />
                  </div>
                </v-card-subtitle>

                <!-- Item Exclusive -->
                <v-card-text>
                  <v-icon left color="primary">mdi-tag</v-icon>
                  Exclusive: {{ item.exclusive ? 'Yes' : 'No' }}
                </v-card-text>
                <div>

                </div>
              </v-card>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="items"
            :server-items-length="total"
            :page.sync="page"
            :items-per-page.sync="itemsPerPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="descending"
            :loading="loading"
            loading-text="Loading... Please wait"
          >
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapFields } from "vuex-map-fields"
import { mapActions } from "vuex"

import SettingsBreadcrumbs from "@/components/SettingsBreadcrumbs.vue"
import NewEditSheet from "@/tag_type/NewEditSheet.vue"
import ProjectCard from '@/project/ProjectCard.vue'

export default {
  name: "TagTypeTable",

  components: {
    NewEditSheet,
    SettingsBreadcrumbs,
    ProjectCard,
  },
  data() {
    return {
      headers: [],
    }
  },

  computed: {
    ...mapFields("tag_type", [
      "table.options.q",
      "table.options.page",
      "table.options.itemsPerPage",
      "table.options.sortBy",
      "table.options.descending",
      "table.options.filters.project",
      "table.loading",
      "table.rows.items",
      "table.rows.total",
    ]),
    ...mapFields("route", ["query"]),
  },

  created() {
    this.project = [{ name: this.query.project }]

    this.getAll()

    this.$watch(
      (vm) => [vm.page],
      () => {
        this.getAll()
      }
    )

    this.$watch(
      (vm) => [vm.q, vm.itemsPerPage, vm.sortBy, vm.descending, vm.project],
      () => {
        this.page = 1
        this.$router.push({ query: { project: this.project[0].name } })
        this.getAll()
      }
    )
  },

  methods: {
    ...mapActions("tag_type", ["getAll", "createEditShow", "removeShow"]),
  },
}
</script>
